module.exports = __webpack_public_path__ + "static/media/ppt.f155f70d.png";